"use strict";
// Automatically generated on publish
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
/**
 * @description Provides the current version number of the Remotion library.
 * @see [Documentation](https://remotion.dev/docs/version)
 * @returns {string} The current version of the remotion package
 */
exports.VERSION = '4.0.150';
